
import { defineComponent, computed, ref, onMounted } from "vue";
import Prism from "prismjs";

export default defineComponent({
  name: "CodeHighlighter",
  props: {
    lang: String,
    fieldHeight: Number
  },
  setup(props) {
    const height = ref(props.fieldHeight);

    const getHeightInPixesls = computed(() => {
      return height.value + "px";
    });

    onMounted(() => {
      Prism.highlightAll();
    });

    return {
      getHeightInPixesls
    };
  },
  components: {}
});
